import backgroundError from '../../images/wave-error.png'
import { appConfig } from "../../config";

function ErrorPage() {
  return (
    <>
      <div class="error-content" style={{ background: `url(${backgroundError})`, backgroundPosition: 'bottom', backgroundRepeat: 'no-repeat' }}>
            <div class="group">
                <h1 class="error-code">404</h1>
                <h4 class="error-title">Error Occured</h4>
                <p class="error-desc">Contact server for help</p>
            </div>
        </div>
    </>
  );
}

export default ErrorPage;